import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class MapOverlayService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * Get  map overlay based on overlayId
	 * @param {String} overlayId
	 */
	getOverlayById(overlayId, callback) {
		const url = `/ecosystem/api/mapOverlays/${overlayId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Get all  map overlays
	 */
	getAllOverlays(callback) {
		const url = `/ecosystem/api/mapOverlays`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Insert map overlay
	 * @param {Array} overlay
	 */
	createOverlay(overlay, callback) {
		const url = `/ecosystem/api/mapOverlays`;
		const body = JSON.stringify({
			overlay
		});
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * update map overlay
	 * @param {String} overlayId
	 * @param {Array} overlay
	 */
	updateOverlay(overlayId, overlay, callback) {
		const url = `/ecosystem/api/mapOverlays/${overlayId}`;
		const body = JSON.stringify({
			overlay
		});
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * delete  map overlay based on overlayId
	 * @param {String} overlayId
	 */
	deleteOverlay(overlayId, callback) {
		const url = `/ecosystem/api/mapOverlays/${overlayId}`;
		this._restClient.exec_delete(url, callback);
	}
}
